 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"announcements-create":"announcements-create","announcements-edit":"announcements-edit","announcements-index":"announcements-index","announcements-view":"announcements-view","articles-index":"articles-index","articles-schedule":"articles-schedule","articles-search":"articles-search","articles-view~draft-sources~sections-edit~staff-contributor-edit":"articles-view~draft-sources~sections-edit~staff-contributor-edit","articles-view~sections-edit":"articles-view~sections-edit","articles-view":"articles-view","sections-edit":"sections-edit","draft-sources":"draft-sources","staff-contributor-edit":"staff-contributor-edit","assignments":"assignments","auth":"auth","dashboard":"dashboard","draft-form":"draft-form","draft-index":"draft-index","generic":"generic","jexy":"jexy","not-found":"not-found","opps-details":"opps-details","opps-edit":"opps-edit","opps-featured":"opps-featured","opps-index":"opps-index","opps-news-draft":"opps-news-draft","opps-record":"opps-record","opps-search":"opps-search","publicists-contributor":"publicists-contributor","publicists-directory":"publicists-directory","release-notes":"release-notes","sample":"sample","sections-directory":"sections-directory","sections-record":"sections-record","sections-view":"sections-view","staff-contributor":"staff-contributor","staff-contributor-edit-editorial":"staff-contributor-edit-editorial","staff-contributor-edit-mailbox":"staff-contributor-edit-mailbox","staff-contributor-edit-public":"staff-contributor-edit-public","staff-contributor-view":"staff-contributor-view","staff-directory":"staff-directory","wiki-directory":"wiki-directory","wiki-search":"wiki-search","wiki-view":"wiki-view"}[chunkId]||chunkId) + "." + {"announcements-create":"d5b8dcd0","announcements-edit":"55b036e7","announcements-index":"c55effe8","announcements-view":"40c8deaa","articles-index":"f30a4ac9","articles-schedule":"13b3b595","articles-search":"5748b979","articles-view~draft-sources~sections-edit~staff-contributor-edit":"7dab3d4b","articles-view~sections-edit":"82722f01","articles-view":"0a4c1e26","sections-edit":"f507d55e","draft-sources":"76bcf389","staff-contributor-edit":"66070f30","assignments":"11eed31e","auth":"f2519dfd","chunk-154413ae":"e3593837","chunk-2d0a31a7":"3a1ecc88","chunk-35a9575e":"2193b8ae","chunk-3b036f6a":"b9190b61","chunk-441e0b36":"ecab9252","chunk-3eb3aa4c":"01a662d8","chunk-47b8da80":"50f7ca5b","chunk-590e5764":"d6063ec7","chunk-21899a6f":"08363f62","chunk-e74c1796":"a91ba7f0","chunk-cd31ca72":"fc364b82","chunk-dc4fedce":"609511a3","chunk-5b2bddb3":"6b7f4f91","chunk-628da1f8":"d5b7e1c9","chunk-bffa0618":"8bb83e54","chunk-c75ad712":"9bba633e","dashboard":"0982e787","draft-form":"47415331","draft-index":"c1ad05c1","generic":"0a4fe3e1","jexy":"a654d412","not-found":"e343773f","opps-details":"cc4cb7fa","opps-edit":"78df1153","opps-featured":"c2db1932","opps-index":"4ef9bd0d","opps-news-draft":"f2c56ef9","opps-record":"6021a671","opps-search":"848802ab","publicists-contributor":"abcf3b8a","publicists-directory":"8abec347","release-notes":"a7db7db4","sample":"2f3888b3","sections-directory":"4dd15b73","sections-record":"7159b783","sections-view":"fb6ea137","staff-contributor":"d6ce2805","staff-contributor-edit-editorial":"216b5141","staff-contributor-edit-mailbox":"41434461","staff-contributor-edit-public":"75f6de44","staff-contributor-view":"cf11429d","staff-directory":"0c11c09f","wiki-directory":"e1181603","wiki-search":"d0935a8c","wiki-view":"1853fe03","chunk-2d21e091":"afa7f52f","chunk-8ff4a234":"0cbc9852","chunk-8ff6721a":"4314dbd7","chunk-901cf2a8":"4d07385e","chunk-901f4326":"85864980","chunk-901f5e0e":"71074667","chunk-90202196":"4f8b6884","chunk-9021433e":"750cb261","chunk-902206b6":"9ee711b9","chunk-9024d65c":"ae15e75e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"announcements-view":1,"articles-index":1,"articles-search":1,"articles-view~draft-sources~sections-edit~staff-contributor-edit":1,"articles-view~sections-edit":1,"articles-view":1,"auth":1,"chunk-154413ae":1,"chunk-35a9575e":1,"chunk-3b036f6a":1,"chunk-441e0b36":1,"chunk-3eb3aa4c":1,"chunk-47b8da80":1,"chunk-590e5764":1,"chunk-21899a6f":1,"chunk-e74c1796":1,"chunk-cd31ca72":1,"chunk-dc4fedce":1,"chunk-5b2bddb3":1,"chunk-628da1f8":1,"chunk-bffa0618":1,"chunk-c75ad712":1,"dashboard":1,"draft-index":1,"jexy":1,"not-found":1,"opps-details":1,"opps-record":1,"release-notes":1,"sections-record":1,"sections-view":1,"staff-contributor":1,"staff-contributor-view":1,"staff-directory":1,"wiki-search":1,"wiki-view":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"announcements-create":"announcements-create","announcements-edit":"announcements-edit","announcements-index":"announcements-index","announcements-view":"announcements-view","articles-index":"articles-index","articles-schedule":"articles-schedule","articles-search":"articles-search","articles-view~draft-sources~sections-edit~staff-contributor-edit":"articles-view~draft-sources~sections-edit~staff-contributor-edit","articles-view~sections-edit":"articles-view~sections-edit","articles-view":"articles-view","sections-edit":"sections-edit","draft-sources":"draft-sources","staff-contributor-edit":"staff-contributor-edit","assignments":"assignments","auth":"auth","dashboard":"dashboard","draft-form":"draft-form","draft-index":"draft-index","generic":"generic","jexy":"jexy","not-found":"not-found","opps-details":"opps-details","opps-edit":"opps-edit","opps-featured":"opps-featured","opps-index":"opps-index","opps-news-draft":"opps-news-draft","opps-record":"opps-record","opps-search":"opps-search","publicists-contributor":"publicists-contributor","publicists-directory":"publicists-directory","release-notes":"release-notes","sample":"sample","sections-directory":"sections-directory","sections-record":"sections-record","sections-view":"sections-view","staff-contributor":"staff-contributor","staff-contributor-edit-editorial":"staff-contributor-edit-editorial","staff-contributor-edit-mailbox":"staff-contributor-edit-mailbox","staff-contributor-edit-public":"staff-contributor-edit-public","staff-contributor-view":"staff-contributor-view","staff-directory":"staff-directory","wiki-directory":"wiki-directory","wiki-search":"wiki-search","wiki-view":"wiki-view"}[chunkId]||chunkId) + "." + {"announcements-create":"31d6cfe0","announcements-edit":"31d6cfe0","announcements-index":"31d6cfe0","announcements-view":"8d34325b","articles-index":"e9d5929d","articles-schedule":"31d6cfe0","articles-search":"e70efc27","articles-view~draft-sources~sections-edit~staff-contributor-edit":"b0c038b1","articles-view~sections-edit":"8fe3f6ed","articles-view":"188dfaa1","sections-edit":"31d6cfe0","draft-sources":"31d6cfe0","staff-contributor-edit":"31d6cfe0","assignments":"31d6cfe0","auth":"0526b92f","chunk-154413ae":"0481c977","chunk-2d0a31a7":"31d6cfe0","chunk-35a9575e":"a55f73c8","chunk-3b036f6a":"0925ddc9","chunk-441e0b36":"21bc03c3","chunk-3eb3aa4c":"e667ddaf","chunk-47b8da80":"381580a4","chunk-590e5764":"444d99df","chunk-21899a6f":"fdf3c61d","chunk-e74c1796":"fdf3c61d","chunk-cd31ca72":"4b6131f8","chunk-dc4fedce":"6ed10615","chunk-5b2bddb3":"e94a0f82","chunk-628da1f8":"f722f401","chunk-bffa0618":"0a06c779","chunk-c75ad712":"0a06c779","dashboard":"fa456b33","draft-form":"31d6cfe0","draft-index":"886da877","generic":"31d6cfe0","jexy":"5cf30557","not-found":"f33ec3ee","opps-details":"a0b3ff0b","opps-edit":"31d6cfe0","opps-featured":"31d6cfe0","opps-index":"31d6cfe0","opps-news-draft":"31d6cfe0","opps-record":"57d22776","opps-search":"31d6cfe0","publicists-contributor":"31d6cfe0","publicists-directory":"31d6cfe0","release-notes":"ac855cf8","sample":"31d6cfe0","sections-directory":"31d6cfe0","sections-record":"31890b88","sections-view":"e70efc27","staff-contributor":"764b0e87","staff-contributor-edit-editorial":"31d6cfe0","staff-contributor-edit-mailbox":"31d6cfe0","staff-contributor-edit-public":"31d6cfe0","staff-contributor-view":"e70efc27","staff-directory":"03e0bb28","wiki-directory":"31d6cfe0","wiki-search":"2274e60b","wiki-view":"a1ba3461","chunk-2d21e091":"31d6cfe0","chunk-8ff4a234":"31d6cfe0","chunk-8ff6721a":"31d6cfe0","chunk-901cf2a8":"31d6cfe0","chunk-901f4326":"31d6cfe0","chunk-901f5e0e":"31d6cfe0","chunk-90202196":"31d6cfe0","chunk-9021433e":"31d6cfe0","chunk-902206b6":"31d6cfe0","chunk-9024d65c":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
